import { useSnackbar } from 'notistack';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthUser, useExchangeToken, useGetRoles } from '@/api';
import { useAuth } from '@/auth/auth-context.tsx';

import { AuthLoaderStyled } from './components';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { handleLoginSuccess } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const callbackRedirectUri = `${origin}/auth/callback`;
  const callbackError = params.get('error');
  const callbackErrorDescription = params.get('error_description');
  const hasDisplayedError = React.useRef(false);

  const { exchangeTokenData, exchangeError } = useExchangeToken(code || '', callbackRedirectUri);
  const { roles } = useGetRoles(exchangeTokenData?.accessToken);

  React.useEffect(() => {
    if (exchangeTokenData && roles) {
      const updatedUserInfo: AuthUser = {
        ...exchangeTokenData.userInfo,
        roles,
      };

      handleLoginSuccess(
        exchangeTokenData.accessToken,
        updatedUserInfo,
        exchangeTokenData.expiresIn,
        exchangeTokenData.refreshToken,
      );

      void navigate('/');
    }
  }, [exchangeTokenData, handleLoginSuccess, navigate, roles]);

  React.useEffect(() => {
    if (exchangeError) {
      void navigate('/');
    }
  }, [exchangeError, navigate]);

  React.useEffect(() => {
    if (callbackError && callbackErrorDescription && !hasDisplayedError.current) {
      enqueueSnackbar({
        message: callbackErrorDescription,
        variant: 'error',
        autoHideDuration: 5000,
      });
      hasDisplayedError.current = true;
      void navigate('/');
    }
  }, [callbackError, callbackErrorDescription, navigate, hasDisplayedError, enqueueSnackbar]);

  return (
    <div
      style={{
        display: 'grid',
        width: '100wv',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AuthLoaderStyled />
    </div>
  );
};

export default AuthCallback;
